<template>
  <div class="box-father">
    <div class="box-header">
      <div class="box-header-left">
        <div class="box-header-left-text">业务基础信息管理&nbsp;/&nbsp;</div>
        <div class="box-header-right">
          <div>非日常巡查自定义管理</div>
        </div>
      </div>
    </div>
    <div class="thewrap">
      <div class="data-source">
        <div class="y-head">
          <div class="tit">数据源</div>

          <div class="y-btns">
            <div class="y-btn" @click="downloadFileFun">
              <span class="el-icon-download"></span>
              <span>模板下载</span>
            </div>
            <div class="y-btn" @click="dialogVisible2 = true">
              <span class="el-icon-upload2"></span>
              <span>数据导入</span>
            </div>
          </div>
        </div>
        <div class="search-box">
          <el-input
            style="margin-right: 12px"
            placeholder="请输入数据源名称"
            prefix-icon="el-icon-search"
            clearable
            v-model="useRuleTable"
          >
          </el-input>
          <el-select
            v-model="tjDeptId"
            :clearable="checkRole('GLLD')"
            placeholder="请选择主办部门"
            @change="useRuleTableFun"
          >
            <el-option
              v-for="item in deptList"
              :key="item.id"
              :label="item.label"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </div>
        <div class="type-list">
          <div
            v-for="item in useRuleList"
            :key="item.useRuleTable"
            :class="[
              'type-list-item',
              { active: form.useRuleTable === item.useRuleTable }
            ]"
            @click="sourceClick(item)"
          >
            <div class="item-top">
              <div class="name">{{ item.useRuleTable }}</div>
            </div>
            <div class="item-bottom">
              <div style="color: #909399">{{ item.deptName }}</div>
              <div class="edit">
                <el-button
                  style="color: #eb3538"
                  @click="delEventTypeFun(item)"
                  icon="el-icon-delete"
                  type="text"
                  >删除</el-button
                >
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="section">
        <div class="biaodan2">
          <div class="biaodan-left">
            <div style="height: 100%; width: 100%">
              <el-form
                :inline="true"
                label-position="left"
                class="demo-form-inline"
                :model="form"
              >
                <el-form-item label="办事人员姓名">
                  <el-input
                    v-model="form.extendTagUsername"
                    clearable
                    placeholder="请输入办事人员姓名"
                  ></el-input>
                </el-form-item>
                <el-form-item label="办事人员手机号">
                  <el-input
                    v-model="form.extendTagTel"
                    clearable
                    placeholder="请输入办事人员手机号"
                  ></el-input>
                </el-form-item>
                <el-form-item label="事项目标名称">
                  <el-input
                    v-model="form.xm"
                    clearable
                    placeholder="请输入事项目标名称"
                  ></el-input>
                </el-form-item>
                <el-form-item label="社区全称">
                  <el-select
                    filterable
                    placeholder="请选择社区全称"
                    clearable
                    v-model="form.sq"
                  >
                    <el-option
                      v-for="item in commcommunityList"
                      :key="item.code"
                      :label="item.pointName"
                      :value="item.pointName"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="联系电话">
                  <el-input
                    v-model="form.lxdh"
                    clearable
                    placeholder="请输入联系电话"
                  ></el-input>
                </el-form-item>
                <el-form-item class="form-item">
                  <el-button @click="onSearch" class="search">查询</el-button>
                  <el-button class="reset" @click="onReset">重置</el-button>
                </el-form-item>
              </el-form>
            </div>
          </div>
        </div>
        <div class="aside">
          <div class="table-top-btns">
            <div class="left-btn"></div>
            <div class="right-btn">
              <el-button
                @click="addDialogFun({}, 1)"
                class="search el-icon-plus"
                >新增</el-button
              >
            </div>
          </div>
          <common-table
            :page="page"
            :dataList="dataList"
            @handleCurrentChange="handleCurrentChange"
            @handleSizeChange="handleSizeChange"
          >
            <template v-slot:commonRunState="{ scope }">
              <el-switch
                @change="
                  value => {
                    extendclRkEdit(value, scope.row);
                  }
                "
                v-model="scope.row.commonRunState"
                active-value="ANY"
                inactive-value="CLOSE"
                active-color="#0495FF"
              >
              </el-switch>
            </template>
            <template v-slot:operation="{ scope }">
              <el-button
                @click="addDialogFun(scope.row, 2)"
                style="color: #0090ff; font-size: 16px"
                type="text"
                >编辑</el-button
              >
              <el-button
                @click="delEventEditFun(scope.row.id)"
                style="color: #eb3538; font-size: 16px"
                type="text"
                >删除</el-button
              >
            </template>
          </common-table>
        </div>
      </div>
    </div>
    <addDialog
      v-if="dialogVisible"
      :dialogVisible.sync="dialogVisible"
      :curItem="curItem"
      :titleName="titleName"
      :commcommunityList="commcommunityList"
      @refreshList="indexPageFun"
    >
    </addDialog>
    <addDialog2
      v-if="dialogVisible2"
      :dialogVisible.sync="dialogVisible2"
      :curItem="curItem"
      :titleName="titleName"
      :commcommunityList="commcommunityList"
      @refreshList="indexPageFun"
    >
    </addDialog2>
  </div>
</template>
<script>
import {
  extendclrRkPage,
  extendclRkEdit,
  delclrk,
  delmanger
} from "@/api/task.js";
import { getDeptTree, downloadFile } from "@/api/systemManagement.js";

import { useRuleTable } from "@/api/base.js";
import commonTable from "@/components/table/index.vue";
import addDialog from "./components/addDialog.vue";
import addDialog2 from "./components/addDialog2.vue";
import index from "@/mixins/index.js";
export default {
  components: {
    commonTable,
    addDialog,
    addDialog2
  },
  mixins: [index],
  data() {
    return {
      form: {
        extendTagUsername: "",
        extendTagTel: "",
        xm: "",
        sq: "",
        sfzh: "",
        lxdh: "",
        commonRunState: "",
        useRuleTable: ""
      },
      tjDeptId: "",
      useRuleTable: "",
      sfyjsxOptions: [
        {
          label: "ANY",
          value: "ANY"
        },
        {
          label: "CLOSE",
          value: "CLOSE"
        }
      ],
      dialogVisible: false,
      dialogVisible2: false,
      page: {
        size: 10,
        page: 1,
        total: 0
      },
      dataList: {
        tableData: [],
        columns: [
          {
            prop: "extendTagUsername",
            label: "办事人员姓名",
            width: 160
          },
          {
            prop: "extendTagTel",
            label: "办事人员手机号",
            width: 160
          },
          {
            prop: "extendTagDeptName",
            label: "办事部门",
            width: 160
          },
          {
            prop: "sq",
            label: "社区全称",
            width: 160
          },
          {
            prop: "xm",
            label: "事项目标名称",
            width: 160
          },
          {
            prop: "nl",
            label: "年龄",
            width: 160
          },
          {
            prop: "sfzh",
            label: "身份证号",
            width: 160
          },
          {
            prop: "jzdz",
            label: "事项目标地址",
            width: 160
          },
          {
            prop: "lxdh",
            label: "联系电话",
            width: 160
          },
          {
            prop: "cjlb",
            label: "类别",
            width: 160
          },
          {
            prop: "cjdj",
            label: "等级",
            width: 160
          },
          {
            prop: "blockName",
            label: "网格名称",
            width: 160
          },
          {
            prop: "extendGzUseRuleTable",
            label: "数据源",
            width: 160
          },

          {
            prop: "bz",
            label: "备注",
            width: 160
          },
          {
            slot: "commonRunState",
            label: "启动状态",
            fixed: "right",
            width: 120
          },
          {
            slot: "operation",
            label: "操作",
            fixed: "right",
            width: 120
          }
        ]
      },
      curItem: {},
      typeList: [],
      titleName: "新增",
      useRuleList: [],
      useRuleListAll: [],
      deptList: []
    };
  },
  mounted() {
    if (this.$route.query) {
      this.form.ghEventTypeId = this.$route.query.ghEventTypeId;
      this.form.sxmc = this.$route.query.sxmc;
    }
    this.getCommcommunityAllFun();
    this.getTree();
  },
  methods: {
    //删除单条事项目录类型
    delEventTypeFun(item) {
      this.$confirm("是否删除该数据", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(async () => {
          const res = await delmanger({
            id: item.id
          });
          if (res.data.code == 200) {
            this.useRuleTableFun();
          } else {
            this.$message.warning(res.data.msg);
          }
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    },
    //删除单条事项目录类型
    delEventEditFun(id) {
      this.$confirm("是否删除该数据", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(async () => {
          const res = await delclrk({
            id: id
          });
          if (res.data.code == 200) {
            this.extendclrRkPage();
          } else {
            this.$message.warning(res.data.msg);
          }
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    },

    sourceClick(item) {
      if (this.form.useRuleTable === item.useRuleTable) {
        return;
      }
      this.form.useRuleTable = item.useRuleTable;
      this.onSearch();
    },
    getDeptId() {
      try {
        const userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
        return userInfo.deptId;
      } catch (error) {
        console.error(error);
        return "";
      }
    },
    checkRole(roleCode) {
      try {
        const userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
        const role = userInfo.roles.find(role => role.roleCode === roleCode);
        return role ? true : false;
      } catch (error) {
        console.error(error);
        return false;
      }
    },
    // 获取部门资源树形
    async getTree() {
      let params = {
        page: 999,
        size: 1,
        pid: "2000000035",
        data: true
      };
      const res = await getDeptTree(params);
      if (res.data.code == 200) {
        this.deptList = res.data.data;
        if (!this.checkRole("GLLD")) {
          this.deptList = res.data.data.filter(
            item => item.id == this.getDeptId()
          );
          this.tjDeptId = this.deptList[0].id;
        }
        if (this.deptList.length > 0) {
          this.useRuleTableFun();
        }
      }
    }, // 获取部门资源树形
    async useRuleTableFun() {
      let params = {
        deptId: this.tjDeptId
      };
      const res = await useRuleTable(params);
      if (res.data.code == 200) {
        this.useRuleList = res.data.data;
        this.useRuleListAll = res.data.data;
        if (this.useRuleList.length > 0) {
          this.form.useRuleTable = this.useRuleList[0].useRuleTable;
        } else {
          this.form.useRuleTable = "";
        }
        this.extendclrRkPage();
      }
    },
    indexPageFun() {
      this.extendclrRkPage();
      this.useRuleTableFun();
    },
    openDialog(item) {
      this.dialogVisible = true;
      this.curItem = { ...item, extendGzUseRuleTable: this.form.useRuleTable };
    },
    addDialogFun(item, type) {
      this.titleName = "新增";
      if (type == 2) {
        this.titleName = "编辑";
      }
      this.dialogVisible = true;
      this.curItem = {
        ...item,
        extendGzUseRuleTable: this.form.useRuleTable,
        type
      };
    },
    handleSizeChange(val) {
      this.page.size = val;
      this.extendclrRkPage();
    },
    handleCurrentChange(val) {
      this.page.page = val;
      this.extendclrRkPage();
    },

    // 查询字典类型列表
    onSearch() {
      this.page.page = 1;
      this.page.size = 10;
      this.extendclrRkPage();
    },
    onReset() {
      this.form.extendTagUsername = "";
      this.form.extendTagTel = "";
      this.form.xm = "";
      this.form.sq = "";
      this.form.sfzh = "";
      this.form.lxdh = "";
      this.form.commonRunState = "";
      this.form.useRuleTable = "";
      this.page.page = 1;
      this.page.size = 10;
      if (this.useRuleList.length > 0) {
        this.form.useRuleTable = this.useRuleList[0].useRuleTable;
      }
      this.extendclrRkPage();
    },
    async selListFun() {
      const res = await selList({});
      this.typeList = res.data.data || [];
    },
    async copyIndexFun(id) {
      const res = await copyIndex({
        id: id
      });
      if (res.data.code == 200) {
        this.$message({
          type: "success",
          message: "复制成功"
        });
        this.onSearch();
      } else {
        this.$message({
          type: "error",
          message: res.data.msg
        });
      }
    },
    async delIndexFun(id) {
      const res = await delIndex({
        id: id
      });
      if (res.data.code == 200) {
        this.$message({
          type: "success",
          message: "删除成功"
        });
        this.extendclrRkPage();
      } else {
        this.$message({
          type: "error",
          message: res.data.msg
        });
      }
    },
    async extendclRkEdit(value, item) {
      const res = await extendclRkEdit({
        ...item,
        commonRunState: value
      });
      if (res.data.code == 200) {
        this.$message({
          type: "success",
          message: "操作成功"
        });
        this.extendclrRkPage();
      } else {
        this.$message({
          type: "error",
          message: res.data.msg
        });
      }
    },
    // 模板下载
    async downloadFileFun() {
      const res = await downloadFile({
        filePath: "/template/通用数据导入模板.xlsx"
      });
      let fileReader = new FileReader();
      fileReader.onload = function() {
        try {
          if (res.code == 300) {
            // 说明是普通对象数据，后台转换失败
            // proxy.MSG.error(res.message);
            return;
          } else {
            // 解析成对象失败，说明是正常的文件流
            let url = window.URL.createObjectURL(new Blob([res.data]));
            let link = document.createElement("a");
            link.style.display = "none";
            link.href = url;
            link.target = "_blank";
            link.setAttribute("download", "通用数据导入模板.xlsx");
            document.body.appendChild(link);
            link.click();
            window.URL.revokeObjectURL(url);
            document.body.removeChild(link);
          }
        } catch (err) {
          console.log(err);
        }
      };
      fileReader.readAsText(res.data);
    },

    // 分页查询
    async extendclrRkPage() {
      this.dataList.tableData = [];
      this.dataList.total = 0;
      if (!this.form.useRuleTable) {
        return;
      }
      let params = {
        ...this.form,
        page: this.page.page,
        size: this.page.size
      };
      const res = await extendclrRkPage(params);
      if (res.data.code == 200) {
        this.dataList.tableData = res.data.data.records
          ? res.data.data.records
          : [];
        this.page.total = res.data.data.total;
      }
    }
  },
  watch: {
    useRuleTable: {
      deep: true,
      handler(sxlx) {
        this.useRuleList = this.useRuleListAll.filter(
          item => item.useRuleTable.indexOf(sxlx) > -1
        );
      }
    }
  }
};
</script>
<style scoped lang="less">
@import "~@/components/less.less";

.biaodan2 {
  width: 100%;
  margin-top: 1px;
  display: block;

  .form-item {
    padding: 0;
    margin: 0;
  }
}

.biaodan-left {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.demo-form-inline {
  height: 100%;
  display: flex;
  flex-wrap: wrap;
  position: relative;
}

.section .el-form-item__label {
  text-align: left;
}

.el-button {
  height: 40px;
  font-size: 16px;
}

.table-header {
  height: 56px;
  padding: 8px 0;
  display: flex;
  justify-content: space-between;
  margin-bottom: 8px;
}

/deep/.el-pagination .el-input--mini .el-input__inner,
/deep/.el-pagination.is-background .btn-next,
/deep/.el-pagination.is-background .btn-prev,
/deep/.el-pagination.is-background .el-pager li,
/deep/.el-pagination__jump .el-input__inner {
  height: 32px;
  line-height: 32px;
}

/deep/.el-pagination.is-background .el-pager li:not(.disabled).active {
  border-radius: 4px;
  border: 1px solid #0495ff;
  color: #0495ff;
  background: none;
}

/deep/.el-pagination__jump {
  margin-left: 0;
}
.thewrap {
  --source-w: 300px;
  display: flex;
  background: white;
  .data-source {
    width: var(--source-w);
    flex-shrink: 0;
    border-right: 1px solid #eee;
    padding: 10px;
    .y-head {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 12px;
      .tit {
        font-family: MiSans, MiSans;
        font-weight: 700;
        font-size: 20px;
        color: #494c4f;
      }
      .y-btns {
        display: flex;
        .y-btn {
          cursor: pointer;
          color: #3caaff;
        }
        .y-btn + .y-btn {
          margin-left: 10px;
        }
      }
    }
    .items {
      height: calc(100% - 40px);
      overflow-y: auto;
      .item {
        overflow: hidden;
        padding: 5px 10px;
        cursor: pointer;
        border: 1px solid transparent;
        background: #f9f9f9;
      }
      .item + .item {
        margin-top: 5px;
      }
      .active {
        border-color: #3caaff;
      }
    }
  }
  .section {
    width: calc(100% - var(--source-w));
  }
}
.type-list {
  height: 700px;
  overflow: auto;

  .type-list-item {
    width: 100%;
    // height: 94px;
    padding: 12px;
    background: #f7faff;
    border-radius: 4px;
    margin-bottom: 12px;
    cursor: pointer;

    .item-top {
      display: flex;
      align-items: center;
      flex-wrap: wrap;

      .name {
        font-family: MiSans, MiSans;
        font-weight: 400;
        font-size: 18px;
        color: #494c4f;
        margin: 0 8px 6px 0;
      }

      .type {
        background: rgba(0, 144, 255, 0.1);
        border-radius: 2px;
        padding: 1px 6px;
        font-family: MiSans, MiSans;
        font-weight: 400;
        font-size: 16px;
        color: #0090ff;
        margin: 0 0 6px 0;
      }
    }

    .item-bottom {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-top: 10px;
    }
  }

  .type-list-item.active {
    border: 1px solid #3caaff;
    background: #f7faff url("~@/assets/image/active.png") center no-repeat;
    background-size: 100% 100%;
    border-radius: 8px;
  }
}
.search-box {
  display: flex;
  margin-bottom: 12px;
}
</style>



// WEBPACK FOOTER //
// src/pages/baseInfo/customEvent/index.vue